import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../../../utils/seo';

export const Route = createFileRoute('/_layout/products/extraction-api/')({
  head: () => buildHead('/products/extraction-api'),
});

